import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const CosmicAlignment = ({ onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 3000);
    
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{
        background: 'radial-gradient(ellipse at center, rgba(30, 58, 138, 0.95), rgba(0, 0, 0, 0.98))'
      }}
    >
      {/* Converging particles */}
      <div className="absolute inset-0 overflow-hidden">
        {Array.from({ length: 24 }).map((_, i) => (
          <div
            key={i}
            className="alignment-particle"
            style={{
              '--particle-angle': `${(i * 360) / 24}deg`,
              '--particle-delay': `${i * 0.05}s`
            }}
          />
        ))}
      </div>

      {/* Central glow */}
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1, delay: 0.3 }}
        className="absolute w-40 h-40 rounded-full"
        style={{
          background: 'radial-gradient(circle, rgba(251, 191, 36, 0.6), rgba(251, 191, 36, 0.2), transparent)',
          filter: 'blur(20px)'
        }}
      />

      {/* Message */}
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.5 }}
        className="relative z-10 text-center"
      >
        <h1 className="font-heading text-5xl md:text-6xl font-light text-white mb-4 tracking-widest">
          You are now aligned.
        </h1>
        <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-amber-400 to-transparent mx-auto" />
      </motion.div>

      {/* Outer ring */}
      <motion.div
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ 
          scale: [0.5, 1.5, 1.5],
          opacity: [0, 0.3, 0]
        }}
        transition={{ duration: 2, delay: 0.3 }}
        className="absolute w-96 h-96 rounded-full border border-amber-400/30"
      />
    </motion.div>
  );
};

export default CosmicAlignment;
